import {injectable} from "inversify";
import axios, {AxiosError, AxiosResponse} from "axios";
import {LocationDataDto, LocationIpDto} from "@/store/player/types";

@injectable()
export class LocationService {

    public async getLocationDataByIp(ip: string): Promise<LocationDataDto> {
        return new Promise<LocationDataDto>((resolve, reject) => {
            axios.get<LocationDataDto>(`https://api.iplocation.net/?ip=${ip}`)
                .then((response: AxiosResponse<LocationDataDto>) => resolve(response.data))
                .catch((error: AxiosError<string>) => reject(error));
        });
    }

    public async getIp(): Promise<LocationIpDto> {

        return new Promise<LocationIpDto>((resolve, reject) => {
            axios.get<LocationIpDto>('https://api.iplocation.net/?cmd=get-ip')
                .then((response: AxiosResponse<LocationIpDto>) => resolve(response.data))
                .catch((error: AxiosError<string>) => reject(error));
        });
    }
}